var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 15V16.333H8.667L8.667 15C8.667 15 8.667 12.333 12.667 12.333C16.667 12.333 16.667 15 16.667 15ZM14.667 9C14.667 8.60444 14.5497 8.21776 14.3299 7.88886C14.1102 7.55996 13.7978 7.30362 13.4324 7.15224C13.0669 7.00087 12.6648 6.96126 12.2768 7.03843C11.8889 7.1156 11.5325 7.30608 11.2528 7.58579C10.9731 7.86549 10.7826 8.22186 10.7054 8.60982C10.6283 8.99778 10.6679 9.39992 10.8192 9.76537C10.9706 10.1308 11.227 10.4432 11.5559 10.6629C11.8848 10.8827 12.2714 11 12.667 11C13.1974 11 13.7061 10.7893 14.0812 10.4142C14.4563 10.0391 14.667 9.53043 14.667 9ZM16.8 12.374C17.1644 12.7101 17.4581 13.1154 17.6642 13.5663C17.8702 14.0172 17.9844 14.5045 18 15V16.333H20V15C20 15 20 12.7 16.8 12.373V12.374ZM16 7C15.7987 7.00005 15.5986 7.03142 15.407 7.093C15.797 7.65226 16.0061 8.31768 16.0061 8.9995C16.0061 9.68132 15.797 10.3467 15.407 10.906C15.5986 10.9679 15.7987 10.9996 16 11C16.5304 11 17.0391 10.7893 17.4142 10.4142C17.7893 10.0391 18 9.53043 18 9C18 8.46957 17.7893 7.96086 17.4142 7.58579C17.0391 7.21071 16.5304 7 16 7ZM9.333 10.334H7.333V8.334H6V10.334H4L4 11.667H6V13.667H7.333V11.667H9.333V10.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency);
export default __webpack_public_path__ + "static/media/agency.bad8bbb27f546483d9ea855464f7314b.svg";
export { ForwardRef as ReactComponent };